<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w Pos-r order_list">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>&gt;
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>&gt;
          订单管理
        </div>
        <left-userinfo state="1"></left-userinfo>
        <div class="right_info_wrap">
          <div class="order-header clearfix">
            <div class="order-tab-title-list">
              <a
                href="javascript:void(0);"
                @click="switchTab(0)"
                class="order-tab-title"
                :class="{ selected: activeIndex == 0 }"
              >
                <p>全部订单</p>
              </a>
              <a
                href="javascript:void(0);"
                @click="switchTab(1)"
                class="order-tab-title"
                :class="{ selected: activeIndex == 1 }"
              >
                <p>
                  待支付(
                  <span style="color:#E2333F;" class="ng-binding">{{
                    statusList["1"]
                  }}</span>
                  )
                </p>
              </a>
              <a
                href="javascript:void(0);"
                @click="switchTab(2)"
                class="order-tab-title"
                :class="{ selected: activeIndex == 2 }"
              >
                <p>
                  待发货
                  <!-- (<span style="color:#E2333F;" class="ng-binding">{{statusList['2']}}</span> ) -->
                </p>
              </a>

              <a
                href="javascript:void(0);"
                @click="switchTab(3)"
                class="order-tab-title"
                :class="{ selected: activeIndex == 3 }"
              >
                <p>
                  待收货
                  <!-- ( <span style="color:#E2333F;" class="ng-binding">{{statusList['3']}}</span> ) -->
                </p>
              </a>

              <!-- 订单搜索 -->
              <div class="order_info_search">
                <el-input
                  class="order_search_text"
                  clearable
                  v-model="keyword"
                  @clear="clearInput"
                  placeholder="输入商品名称或订单编号"
                ></el-input>
                <i class="el-icon el-icon-mysearch" @click="order_search"></i>
              </div>
            </div>
            <div style="clear:both;"></div>
          </div>

          <div
            class="user-order-content-wrapper"
            v-if="orderList && orderList.length > 0"
          >
            <table class="orderlist-title-wrapper">
              <tbody>
                <tr>
                  <td class="orderlist-title-name">订单商品</td>
                  <td class="orderlist-title-money">金额</td>
                  <td class="orderlist-title-status">全部状态</td>
                  <td class="orderlist-title-opt">操作</td>
                </tr>
              </tbody>
            </table>

            <div
              class="user-order-content"
              v-for="item in orderList"
              :key="item.id"
            >
              <el-row
                class="title-info"
                v-if="item.products && item.products.length > 0"
              >
                <el-col :span="6">{{ item.updated_at }}</el-col>
                <el-col :span="6">
                  订单编号:
                  <span>{{ item.id }}</span>
                  <span
                    class="copy-btn"
                    @click="copyOrderId"
                    :data-clipboard-text="item.id"
                    >复制</span
                  >
                </el-col>

                <el-col :span="12"
                  >共{{ item.products && item.products.length }}件商品</el-col
                >
              </el-row>
              <table class="user-order-table">
                <tbody class="user-order-list">
                  <tr
                    class="user-order-item"
                    v-for="(product, index) in item.products"
                    v-show="index < 5 || (index >= 5 && item.view_product_more)"
                    :key="product.id"
                  >
                    <td class="user-order-name">
                      <el-row v-if="!product.group_product_id">
                        <el-col :span="4">
                          <img alt="商品图片" :src="image(item, product)" />
                        </el-col>
                        <el-col :span="17" class="user-order-product-title">
                          <div>{{ product.name }}</div>
                          <div v-if="item.type != '10'">
                            SKU：{{ decodeURIComponent(product.sku) }}
                          </div>
                        </el-col>
                        <el-col :span="2" class="user-order-product-count"
                          >X {{ product.quantity }}</el-col
                        >
                      </el-row>
                      <div v-else class="groups">
                        <div class="title">
                          组合商品单号：{{ product.group_product_id }}
                        </div>
                        <div
                          class="group"
                          v-for="(group, index) in product.groups"
                          :key="index"
                        >
                          <img :src="group.product_image || goodsDefault" alt />
                          <div class="name">{{ group.name }}</div>
                          <div class="num">X {{ group.quantity }}</div>
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="index == 0"
                      :rowspan="item.products.length"
                      style="color:#FC0010"
                    >
                      {{ item.total | jifen }}
                    </td>
                    <td
                      v-if="index == 0"
                      :rowspan="item.products.length"
                      style="color:#FD6C17"
                    >
                      {{ item.status }}
                    </td>
                    <td
                      v-if="index == 0 && item.type !== '10'"
                      :rowspan="item.products.length"
                      class="user-order-operation"
                    >
                      <div
                        v-show="item.status_id == 1"
                        v-if="showType(item.type)"
                      >
                        <el-button
                          style="color:#FB6929;border-color:#FB6929"
                          @click.native="doPayNow(item)"
                          >立即支付</el-button
                        >
                      </div>
                      <div
                        v-show="item.status_id == 1"
                        v-if="showType(item.type)"
                      >
                        <el-button
                          class="cancel-btn"
                          @click="cancelOrder(item.id)"
                          >取消订单</el-button
                        >
                      </div>
                      <div
                        v-show="
                          product.supplier !== 'quyundong' &&
                            item.type != 5 &&
                            item.type !== '11'
                        "
                      >
                        <el-button
                          class="cancel-btn"
                          v-if="showType(item.type)"
                          @click="goDetail(item.id)"
                          >查看订单</el-button
                        >
                      </div>
                      <div v-show="item.can_del || item.status_id === 7">
                        <el-button
                          class="cancel-btn"
                          @click="deleteOrder(item.id)"
                          >删除订单</el-button
                        >
                      </div>
                      <div
                        v-show="
                          item.order_evaluate_status === 1 && item.type === '0'
                        "
                      >
                        <el-button
                          class="cancel-btn"
                          @click="goEvaluate(item.id)"
                          >订单评价</el-button
                        >
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="item.products.length > 5"
                    @click="item.view_product_more = !item.view_product_more"
                    style="text-align: center; cursor: pointer; height: 25px"
                  >
                    {{
                      item.view_product_more ? "收起更多商品" : "查看更多商品"
                    }}<i
                      class="el-icon el-icon-arrow-right"
                      style="font-size: 12px"
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <el-pagination
            v-if="totalList.total > 0"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="4"
            layout="prev, pager, next, jumper"
            :total="totalList.total"
          ></el-pagination>
          <is-empty v-if="isEmpty"></is-empty>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import IsEmpty from "@/components/is-empty";
import GOODSDEFAULT from "@/assets/images/goods_default.jpg";
import Clipboard from "clipboard";
import eleImg from "@/assets/images/eleme.png";
import mtImg from "@/assets/images/meituan.png";
import zfb_qym from "@/assets/images/zfb_qym.png";
import xiecheng from "@/assets/images/xiecheng.png";
import ali_city from "@/assets/images/ali_city.png";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    IsEmpty
  },
  data() {
    return {
      keyword: "",
      activeIndex: 0,
      orderList: [],
      curPage: 0,
      perPage: 4,
      statusList: {},
      goodsDefault: GOODSDEFAULT,
      isEmpty: false,
      totalList: {},
      currentPage: 1
    };
  },
  created() {
    this.name = this.$route.query.name;
  },
  methods: {
    getData() {
      this.curPage++;
      let obj = {
        status_id: this.activeIndex,
        page: this.curPage,
        limit: this.perPage
      };
      if (this.keyword) {
        obj.keyword = this.keyword;
      }
      this.$reqGet("api/ecomm/order", obj).then(res => {
        let data = res.data;
        this.totalList = data.pagination;
        data.data.forEach(item => {
          item.view_product_more = false;
        });
        this.orderList = data.data;
        this.initOrderList();
        if (this.orderList.length == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      });
    },
    clearInput() {
      this.keyword = "";
      this.order_search();
    },
    initOrderList() {
      this.orderList.map((order, index) => {
        let products = [];
        let groups = {};
        order.products.map(group => {
          if (group.group_product_id) {
            if (groups[group.group_product_id]) {
              groups[group.group_product_id].push(group);
            } else {
              groups[group.group_product_id] = [];
              groups[group.group_product_id].push(group);
            }
          } else {
            products.push(group);
          }
        });
        for (let key in groups) {
          let obj = {
            group_product_id: key,
            groups: groups[key]
          };
          products.push(obj);
        }
        this.orderList[index].products = products;
      });
    },
    getStatusCount() {
      this.$reqGet("api/store/order/status_count").then(res => {
        this.statusList = res.data.data;
      });
    },
    clearData() {
      this.orderList = [];
      this.totalList = {};
      this.curPage = 0;
    },
    switchTab(index) {
      this.activeIndex = index;
      this.clearData();
      this.getData();
    },
    order_search() {
      this.clearData();
      this.getData();
    },
    doPayNow(item) {
      if (item.products[0].supplier === "quyundong") {
        this.$router.push({
          name: "qyd-submit-order",
          params: { order_id: item.id }
        });
        return;
      }
      this.$router.push({
        name: "submit-order",
        params: { order_id: item.id }
      });
    },
    goDetail(id) {
      const routeData = this.$router.resolve({
        path: "/OrderDetail/" + id
      });
      window.open(routeData.href, "_blank");
    },
    goEvaluate(id) {
      const routeData = this.$router.resolve({
        name: "evaluate",
        query: { order_id: id }
      });
      window.open(routeData.href, "_blank");
    },
    cancelOrder(id) {
      this.$confirm("请确认是否取消订单?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqGet("api/store/order/cancel/" + id).then(res => {
          if (res.data.success) {
            this.orderList.map((ele, index) => {
              if (ele.id == id) {
                this.orderList.splice(index, 1);
                this.statusList["1"]--;
              }
            });
            this.$message({
              type: "success",
              message: "取消订单成功!"
            });
          }
        });
      });
    },
    deleteOrder(id) {
      this.$confirm("请确认是否删除订单?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqPost("api/store/order/hidden", { order_id: id }).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除订单成功!"
            });
            this.curPage = this.curPage - 1;
            this.getData();
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.curPage = val - 1;
      this.getData();
    },
    copyOrderId() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", () => {
        clipboard.destroy();
      });
      this.$message({
        type: "success",
        message: "复制成功!"
      });
    },
    image(item, product) {
      let url;
      switch (item.type) {
        case "7":
          url = eleImg;
          break;
        case "9":
          url = mtImg;
          break;
        case "10":
          url = zfb_qym;
          break;
        case "11":
          url = xiecheng;
          break;
        case "13":
          url = ali_city;
          break;
        default:
          url = product.product_image || this.goodsDefault;
          break;
      }
      return url;
    },
    showType(type) {
      if (
        type !== "7" &&
        type !== "8" &&
        type !== "9" &&
        type !== "10" &&
        type !== "11" &&
        type !== "13"
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.getData();
    this.getStatusCount();
  }
};
</script>

<style lang="less" scoped>
.el-button:focus {
  color: #606266;
}
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right_info_wrap {
  position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  left: 220px;
  box-sizing: border-box;
  padding: 22px 25px 60px;
  padding-bottom: 15px;
  background-color: #fff;
  .order-header {
    height: 37px;
    border-bottom: 2px solid #dadada;
    box-sizing: border-box;
    .order-tab-title-list {
      display: flex;
      .order-tab-title {
        width: 135px;
        max-width: 135px;
        border-bottom: none;
        height: 30px;
        color: #666;
        text-align: center;
        padding-bottom: 5px;
      }
      p {
        display: inline-block;
        width: 100%;
        height: 18px;
        margin-top: 6px;
        line-height: 16px;
        font-size: 16px;
        border-right: 1px solid #bfbfbf;
        color: #999;
      }
      .selected {
        font-size: 14px;
        border-bottom: 2px solid #fd6e27;
        p {
          color: #e2333f;
          height: 20px;
          margin-top: 5px;
          line-height: 18px;
          font-size: 20px;
        }
      }
    }
    .order_info_search {
      position: absolute;
      right: 26px;
      width: 250px;
      height: 26px;
      line-height: 24px;
      padding: 2px 10px 2px 5px;
      border: 1px solid #e2e0dc;
      display: flex;
      align-items: center;
      .order_search_text {
        flex: 1;
        display: flex;
        align-items: center;
        /deep/.el-input__inner {
          border: none;
          height: 26px;
          line-height: 26px;
          border-radius: 0;
          padding: 5px 0;
          border-right: 1px solid #e2e0dc;
        }
        /deep/ .el-input__suffix {
          display: flex;
          align-items: center;
          margin-right: 0;
        }
      }

      i {
        padding-left: 10px;
        color: #6d6d6d;
        cursor: pointer;
      }
    }
  }
  .user-order-content-wrapper {
    min-height: 400px;
    .orderlist-title-wrapper {
      text-align: center;
      box-sizing: border-box;
      background-color: #fbfbfb;
      border: 1px solid #f5f5f5;
      margin: 20px 0;
      td {
        width: 162px;
        height: 40px;
        line-height: 40px;
        color: #222222;
      }
      .orderlist-title-name {
        width: 550px;
      }
    }
    .user-order-content {
      border: 1px solid #f5f5f5;
      margin-bottom: 10px;
      .title-info {
        background-color: #fbfbfb;
        padding: 10px 20px;
        overflow: hidden;
        color: #999;
        span {
          color: #222;
        }
        .el-col:last-child {
          text-align: right;
        }
      }
      .user-order-table {
        td {
          width: 150px;
          height: 105px;
          text-align: center;
          vertical-align: middle;
          border-left: 1px solid #f5f5f5;
          box-sizing: border-box;
        }
        .user-order-name {
          width: 500px;
          box-sizing: border-box;
          padding-left: 10px;
          border-left: none;
          img {
            width: 60px;
            height: 60px;
            // margin-top: 10px;
          }
          .user-order-product-title {
            text-align: left;
            width: 311px;
            height: 57px;
            color: #222;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .user-order-product-count {
            line-height: 57px;
            text-align: right;
            color: #999;
          }
          > .groups {
            padding: 10px;
            border: 1px solid #e4e4e4;
            background: #fbfbfb;
            margin: 10px 10px 10px 0px;
            text-align: left !important;
            > .title {
              padding-bottom: 10px;
            }
            .group {
              display: flex;
              margin-bottom: 20px;
              align-items: center;
              > .name {
                margin-left: 10px;
                width: 311px;
                height: 57px;
                color: #333;
              }
              > .num {
                line-height: 57px;
                text-align: right;
                color: #999;
                margin-left: 20px;
              }
            }
          }
        }
        .user-order-operation {
          > div {
            margin: 8px;
          }
          .el-button {
            width: 70px;
            height: 26px;
            line-height: 26px;
            padding: 0;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(102, 102, 102, 1);
          }
          .cancel-btn:hover {
            color: #666;
          }
        }
      }
    }
  }
}
.el-pagination {
  padding: 10px 15px;
  text-align: right;
  font-weight: normal;
}
.right_info_wrap /deep/ .el-pager li {
  border: 1px solid #ddd;
  margin-right: 5px;
}
.right_info_wrap /deep/ .el-pager li.active {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
.right_info_wrap /deep/ .el-pager li:hover {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
.copy-btn {
  color: #666666 !important;
  font-size: 12px;
  margin-left: 5px;
  background-color: #eeeeee;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/order-list.vue